import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";

const MEDAL = ["bg-gold text-ink", "bg-ink/10 text-ink", "bg-terra/20 text-terra"];
const LABEL = ["Gold", "Silver", "Bronze"];

export default function Leaderboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/customer/leaderboard").then((r) => setData(r.data)).catch(() => setData({ top: [], me: null, month: "" })); }, []);
  if (!data) return null;

  return (
    <div className="bg-white border border-ink/10 rounded-3xl p-6" data-testid="leaderboard">
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-serif text-xl font-bold flex items-center gap-2"><Trophy size={18} className="text-gold" /> Top referrers</h3>
        <span className="text-[11px] font-mono uppercase tracking-widest text-ink/50" data-testid="leaderboard-month">{data.month}</span>
      </div>
      {data.top.length === 0 ? (
        <p className="mt-3 text-sm text-ink/60" data-testid="leaderboard-empty">No confirmed referrals yet this month — the first booking through your link puts you at #1.</p>
      ) : (
        <ol className="mt-4 space-y-2" data-testid="leaderboard-list">
          {data.top.map((r) => (
            <li key={r.rank} className={`flex items-center gap-3 rounded-2xl px-3 py-2.5 ${r.is_me ? "bg-sand ring-1 ring-terra/40" : ""}`} data-testid={`leaderboard-row-${r.rank}`}>
              <span className={`w-7 h-7 rounded-full grid place-items-center text-xs font-bold ${r.rank <= 3 ? MEDAL[r.rank - 1] : "bg-ink/5 text-ink/60"}`}>{r.rank}</span>
              {r.picture ? <img src={r.picture} alt="" referrerPolicy="no-referrer" className="w-8 h-8 rounded-full" /> : <span className="w-8 h-8 rounded-full bg-ink text-sand grid place-items-center text-xs font-bold">{r.name[0]}</span>}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{r.is_me ? "You" : r.name}{r.rank <= 3 && <span className="ml-2 text-[10px] font-mono uppercase tracking-wider text-ink/50" data-testid={`leaderboard-badge-${r.rank}`}>{LABEL[r.rank - 1]} badge</span>}</p>
                <p className="text-xs text-ink/50">{r.bookings} confirmed booking{r.bookings === 1 ? "" : "s"}</p>
              </div>
            </li>
          ))}
        </ol>
      )}
      {data.me && data.me.rank > 10 && <p className="mt-3 text-xs text-ink/60" data-testid="leaderboard-me">You're #{data.me.rank} this month with {data.me.bookings} booking{data.me.bookings === 1 ? "" : "s"}.</p>}
    </div>
  );
}
